var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.973 16.4137C10.8296 16.4118 9.73345 15.9567 8.92497 15.148C8.1165 14.3394 7.66162 13.2432 7.66003 12.0997C7.66136 10.9558 8.11626 9.85922 8.92498 9.05032C9.73369 8.24141 10.8302 7.78626 11.974 7.78467C13.118 7.78599 14.2148 8.24103 15.0237 9.04996C15.8327 9.8589 16.2877 10.9557 16.289 12.0997C16.2874 13.2435 15.8323 14.34 15.0234 15.1487C14.2145 15.9574 13.1179 16.4123 11.974 16.4137H11.973Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.791 17.1808C12.8912 17.5074 11.9217 17.5937 10.9782 17.4313C10.0348 17.2689 9.14997 16.8634 8.41105 16.2548C7.61443 15.5977 7.01902 14.7296 6.69305 13.7498L6.69105 13.7438L1.93605 5.50977C0.230831 8.11898 -0.381788 11.2934 0.230048 14.3498C0.530499 15.8938 1.13418 17.3629 2.00616 18.6721C2.87814 19.9812 4.0011 21.1045 5.31005 21.9768C6.68439 22.9006 8.23652 23.5274 9.86705 23.8168L13.791 17.1818V17.1808Z",
    fill: "#4AAE48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7601 6.70684C21.8606 4.8973 20.5215 3.34232 18.8655 2.18428C17.2095 1.02624 15.2894 0.302133 13.2811 0.0782663C11.2727 -0.1456 9.24032 0.137926 7.36993 0.902883C5.49955 1.66784 3.85095 2.88979 2.57507 4.45684L6.59107 11.4128C6.75636 10.1249 7.38077 8.93987 8.34962 8.07537C9.31848 7.21086 10.5667 6.72493 11.8651 6.70684H22.7601Z",
    fill: "#EA3939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9261 23.9997C14.9361 23.9997 17.8171 22.8707 20.0361 20.8217C22.2636 18.7702 23.6278 15.9486 23.8521 12.9287C23.9812 11.1803 23.7273 9.4248 23.1081 7.78467H15.2521C15.9066 8.3024 16.4348 8.96212 16.7969 9.71398C17.159 10.4658 17.3454 11.2902 17.3421 12.1247C17.3342 13.3516 16.9183 14.541 16.1601 15.5057L11.1521 23.9757C11.4101 23.9917 11.6701 23.9997 11.9261 23.9997Z",
    fill: "#FED14B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.f56fce18baf8d6bdcac98649a45e1095.svg";
export { ForwardRef as ReactComponent };